/**
 * The next free `<base>_copy`, `<base>_copy2`, `<base>_copy3`… key for a
 * duplicated template entry.
 *
 * The ticket-type template editor and the per-customer override panel both
 * duplicate additional fields and line items under the same rule, and had
 * four copies of the loop between them.
 *
 * Taking the "is this key taken?" probe as a parameter also keeps it out of a
 * loop body. Closing over a `let` that the loop reassigns is what tripped
 * `no-loop-func` at each of those sites — harmless there because `.some()`
 * runs synchronously, but it reads like a capture bug every time someone
 * looks at it.
 */
export function uniqueCopyKey(base: string, isTaken: (key: string) => boolean): string {
  const first = `${base}_copy`;
  if (!isTaken(first)) return first;

  for (let n = 2; ; n++) {
    const candidate = `${base}_copy${n}`;
    if (!isTaken(candidate)) return candidate;
  }
}
